import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import style from '../css/betSlipModalSliderContainer.css';
import BetSlipModal from './betSlipModal';
import {getText} from '../../../helpers/localization';
import {isLocalStorageAvailable} from '../../../helpers/systemHelpers';
import {ASSETS_URL} from '../../../constants/endpoints';
import Counter from '../components/counter';
import ReactSensor from 'resize-sensor';
// actions
import {openCloseBetSlipModal} from '../actions/betSlipActions';
import {openCloseSettings} from '../../../actions/settingsActions';
import BetHistory from "./betHistory";
import {getItem, setItem} from "../../../helpers/localStorageHelpers";
import {UNREAD_BETS} from "../../../constants/localStorage";
import {toggleUnreadBetsNotification} from "../../../actions/systemActions";
import {openCloseHelpPages} from "../../../actions/helpPagesActions";
import {OPERATOR} from "../../../constants/operator";
import {VOIDED} from "../../../constants/identifiers";
import {isBetSettled, removeExpiredBets} from '../helpers/betHelpers';
import {MATCHDAY_MODULE_TYPE} from "../modules/matchday/constants/identifiers";
import {getAccaBetName, getRoundedOdds} from "../modules/matchday/helpers/matchdayHelper";
import {openCloseMyOffer} from "../../../actions/promoBetActions";

let gameCard;
let leftValue;
let reactSensor;
let betSlipPosition;
let betSlipBandWidth;
let betSlipContainer;

const mapStateToProps = (state, ownProps) => {
    return {
        isBetSlipModalOpen: state.vpp.isBetSlipModalOpen,
        openBetsList: state.vpp.openBetsList,
        settledBets: state.vpp.settledBets,
        isSettingsOpen: state.vpp.isSettingsOpen,
        isBetHistoryOpen: state.vpp.isBetHistoryOpen,
        isUnreadBetsNotificationToggled: state.vpp.isUnreadBetsNotificationToggled,
        showHeader: state.vpp.showHeader,
        games: state.vpp.games,
        newPromoFlag: state.vpp.newPromoFlag,
        selectedGameIndex: state.vpp.selectedGameIndex,
        systemLanguage: state.vpp.systemLanguage,
        serverTimeOffset: state.vpp.serverTimeOffset,
        events: state.vpp.events,
    };
};

class BetSlipModalSliderContainer extends Component {

    constructor(props) {
        super(props);

        let store = this.props.store;
        let storeData = store.getState();

        this.state = {
            selectedGameIndex: storeData.vpp.selectedGameIndex,
            isBetSlipModalOpen: storeData.vpp.isBetSlipModalOpen,
            isSettingsOpen: storeData.vpp.isSettingsOpen,
            openBetsList: storeData.vpp.openBetsList,
            settledBets: storeData.vpp.settledBets,
            isBetHistoryOpen: storeData.vpp.isBetHistoryOpen,
            isUnreadBetsNotificationToggled: storeData.vpp.isUnreadBetsNotificationToggled,
            showHeader: storeData.vpp.showHeader,
            newPromoFlag: storeData.vpp.newPromoFlag,
            games: storeData.vpp.games,
            systemLanguage: storeData.vpp.systemLanguage,
            serverTimeOffset: storeData.vpp.serverTimeOffset,
            events: storeData.vpp.events,
        };

    }

    componentDidMount() {
        gameCard = document.getElementById('gameCard');
        leftValue = gameCard.offsetLeft;
        betSlipBandWidth = document.getElementById('bet_slip_button').offsetWidth;
        betSlipContainer = document.getElementById('bet_slip_container').offsetWidth;
        betSlipPosition = gameCard.offsetLeft + (betSlipBandWidth - betSlipContainer > 0 ? (betSlipBandWidth - betSlipContainer) / 2 : 0);
        reactSensor = new ReactSensor(document.getElementById('gameCardContainer'), this._updatePosition.bind(this));
    }

    componentWillUnmount() {
        reactSensor.detach();
    }

    _updatePosition() {
        leftValue = gameCard.offsetLeft;
        betSlipBandWidth = document.getElementById('bet_slip_button').offsetWidth;
        betSlipContainer = document.getElementById('bet_slip_container').offsetWidth;
        betSlipPosition = gameCard.offsetLeft + (betSlipBandWidth - betSlipContainer > 0 ? (betSlipBandWidth - betSlipContainer) / 2 : 0);
        this.forceUpdate();
    }

    componentWillReceiveProps(nextProps) {
        let store = this.props.store;
        let storeData = store.getState();

        let existsUnreadSettledBets = false;
        if (isLocalStorageAvailable) {
            let unreadLocalBets = getItem(storeData.vpp.playerUID, UNREAD_BETS);
            if (unreadLocalBets !== undefined && unreadLocalBets !== null) {
                existsUnreadSettledBets =
                    !unreadLocalBets.playerWasNotified &&
                    !unreadLocalBets.isPlaceBetResponse &&
                    unreadLocalBets.settledBets !== undefined &&
                    unreadLocalBets.settledBets.length > 0 &&
                    unreadLocalBets.settledBets.find((bets) => (bets.Bets.find((b) => b.Prize && b.State !== VOIDED) !== undefined  && isBetSettled(store, bets, this.state.serverTimeOffset) && !bets.isRead && !bets.isFlashed)) !== undefined;

                if (existsUnreadSettledBets && !this.state.isUnreadBetsNotificationToggled) {
                    this.props.store.dispatch(toggleUnreadBetsNotification());
                    setTimeout(() => this.props.store.dispatch(toggleUnreadBetsNotification()), 10000);
                    unreadLocalBets.playerWasNotified = true;
                    this._setFlashed(unreadLocalBets.settledBets);
                    setItem(storeData.vpp.playerUID, UNREAD_BETS, storeData.vpp.playerUID !== undefined ? unreadLocalBets : {
                        placedBets: [],
                        settledBets: []
                    });
                }
            }
        }

        if (nextProps && storeData) {
            this.setState({
                selectedGameIndex: storeData.vpp.selectedGameIndex,
                isBetSlipModalOpen: storeData.vpp.isBetSlipModalOpen,
                isSettingsOpen: storeData.vpp.isSettingsOpen,
                openBetsList: storeData.vpp.openBetsList,
                settledBets: storeData.vpp.settledBets,
                isBetHistoryOpen: storeData.vpp.isBetHistoryOpen,
                isUnreadBetsNotificationToggled: storeData.vpp.isUnreadBetsNotificationToggled,
                showHeader: storeData.vpp.showHeader,
                newPromoFlag: storeData.vpp.newPromoFlag,
                games: storeData.vpp.games,
                systemLanguage: storeData.vpp.systemLanguage,
                serverTimeOffset: storeData.vpp.serverTimeOffset,
                events: storeData.vpp.events,
            });
        }
    }

    _setFlashed(bets) {
        bets.map((sb, index) => {
            sb.isFlashed === true ? '' : sb.isFlashed = true
        });
    }

    _handleExpandCollapse() {
        this.props.store.dispatch(openCloseBetSlipModal());
    }

    _onClickHelpPages() {
        this._handleExpandCollapse();
        this.props.store.dispatch(openCloseHelpPages())
    }

    _onClickPromoIcon() {
            this._handleExpandCollapse();

            this.props.store.dispatch(openCloseMyOffer());
        }

    _onClickSettings() {
        this._handleExpandCollapse();
        this.props.store.dispatch(openCloseSettings())
    }

    render() {

        removeExpiredBets(this.state, this.props.store);

        let isOpenStyle = this.state.isBetSlipModalOpen
            ? style.open
            : '';
        let betButtonStyle = this.state.isBetSlipModalOpen
            ? style.modalButtonBottomContainer : style.modalButtonTopContainer;
        let displayStyle = this.state.isBetSlipModalOpen
            ? '' : style.noDisplay;

        let modalOnClick = isOpenStyle
            ? () => this.props.store.dispatch(openCloseBetSlipModal())
            : null;
        let isMatchdayChannel = this.state.games[this.props.store.getState().vpp.selectedGameIndex].type == MATCHDAY_MODULE_TYPE;
        const bottomOffsetHeight = 0;

        let smallText = (<div
            className={`${style.modalButtonText} ${style.hideSmallText}`}>{getText('CLOSE_SLIP', this.props.store)}</div>);
        let largeText = (<div
            className={`${style.modalButtonText} ${style.hideLargeText}`}>{getText('CLOSE_BET_SLIP', this.props.store)}</div>);

        let betSlip = this.state.isBetSlipModalOpen ? (
                <div className={style.modalButtonTextContainer}> {largeText} {smallText} </div>)
            : (<div className={style.modalButtonText}>{getText('BET_SLIP', this.props.store)}</div>)

        let openBetsToAppear = this.state.openBetsList.filter(eventBet => eventBet.bets.length === 1);
        let counterUI = this.state.openBetsList.length > 0
            ? <Counter animate={true} store={this.props.store} count={openBetsToAppear.length}
                       wrapperStyle={style.counterWrapper}/>
            : null;

        let betContainerContent = this.state.isBetHistoryOpen
            ? <BetHistory store={this.props.store}/>
            : <BetSlipModal store={this.props.store}/>;

        let helpButton;
        if (OPERATOR.showHelp) {
            helpButton = (<img id={'help_button'} src={`${ASSETS_URL}systemIcons/info.svg`} className={style.helpButton}
                               alt={'help button'} onClick={() => this._onClickHelpPages()}/>);
        }

        let promoButton;
        if(OPERATOR.promoToolEnabled) {
            let promoButtonIconDot = '';
            if (this.state.newPromoFlag) {
                promoButtonIconDot = style.promoButtonDot;
            }
            promoButton =
                (<div className={style.promoButtonContainer}><img id={'promo_button'}
                                                                  src={`${ASSETS_URL}promo/giftIconWhite.png`}
                                                                  className={style.promoButton}
                                                                  alt={'promo button'}
                                                                  onClick={() => this._onClickPromoIcon()}/>
                    <div className={promoButtonIconDot}></div>
                </div>);
        }

        let settingsButton;
        if (OPERATOR.showSettings) {
            settingsButton = (
                <img id={'settings_button'} src={`${ASSETS_URL}systemIcons/cog.svg`} className={style.settingsButton}
                     alt={'settings button'} onClick={() => this._onClickSettings()}/>);
        }
        let accordionStyle = `${style.modalButton} ${this.state.isUnreadBetsNotificationToggled
            ? style.flashingButton
            : ''}`;

        let betslipAcca = '';
        let accaBetItems = this.state.openBetsList.filter(bet =>
            bet.bets.length > 1 &&
            new Set(bet.bets.map(b => b.event.eventId)).size == bet.bets.length
        );
        if (accaBetItems.length == 1 && accaBetItems[0].bets.length > 1) {
            let accaFoldName = getAccaBetName(accaBetItems[0].bets.length, this.props.store);
            let odd = getRoundedOdds(accaBetItems[0].bets, true);
            odd = odd.toString().split(".")[0].length <= 5 ? odd : '';
            let bonus;
            if (OPERATOR.accaBoostBonusEnabled) {
                bonus = JSON.parse(OPERATOR.accaBoostBonusPercentage)[accaBetItems[0].bets.length];
            }
            betslipAcca = <div className={style.betslipAmount}>
                {getText('1', this.props.store) + ' ' + getText('x', this.props.store) + ' '}
                {accaFoldName} {odd}
                {
                    !this.state.isBetSlipModalOpen && OPERATOR.accaBoostBonusEnabled && bonus ?
                        <Fragment> <span className={style.plus}>{getText('+', this.props.store)}</span>
                            <span>{getText('Bonus_Info', this.props.store, [bonus])}</span>
                        </Fragment> : ''
                }
            </div>
        }

        let bounceClass = this.state.openBetsCount == undefined || (this.state.openBetsCount < openBetsToAppear.length) ?
            style.betslipBounceAnim : '';
        if ((this.state.openBetsCount != openBetsToAppear.length)) {
            setTimeout(() => {
                this.setState({...this.state, openBetsCount: openBetsToAppear.length});
            }, 200);
        }
        let isMobileDevice = window.innerWidth <= 350;
        let insideContainerHeight = this.props.modalHeight - bottomOffsetHeight;
        let insideContainerStyle = isMatchdayChannel && isMobileDevice ? {height: insideContainerHeight + 'px'} : {};
        return (<Fragment>
            <div id={'bet_slip_button'} className={`${style.modalOutsideContainer} ${isOpenStyle} ${bounceClass}`}
                 onClick={() => this._handleExpandCollapse()}
                 style={{height: `${isOpenStyle}` ? (this.props.modalHeight + 'px') : 0 }}>
                <div className={`${betButtonStyle}`}>
                    <div id={'bet_slip_counter'} className={`${accordionStyle}`}>
                        {counterUI}
                    </div>
                    {promoButton}
                    <div className={`${accordionStyle}`}>
                        {betSlip}
                        {betslipAcca}
                    </div>
                    {helpButton}
                    {settingsButton}
                </div>
                <div id={'bet_slip_container'} className={`${style.modalInsideContainer} ${displayStyle}`}
                     onClick={(e) => e.stopPropagation()}
                     style={insideContainerStyle}>
                    {betContainerContent}
                </div>
            </div>
        </Fragment>);
    }

}

export default connect(mapStateToProps)(BetSlipModalSliderContainer);



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/containers/betSlipModalSliderContainer.js